export const environment = {
  production: true,
  API_URL: 'https://api.questatlas.world',
  GOOGLE_CLIENT_ID: '706691931132-i8cb48nc2ihcb7feoit717epgvh3drki.apps.googleusercontent.com',
  FACEBOOK_CLIENT_ID: '808593106867576',
  mapboxPublicToke: 'pk.eyJ1IjoibmItcXVlc3RhdGxhcyIsImEiOiJjbDluNGtldGwwM3hzM29wa21kMGdibTA4In0.WJM6UGHfTzt5PAJ9a_gcmQ',
  mapboxToken: 'sk.eyJ1IjoibmItcXVlc3RhdGxhcyIsImEiOiJjbG50Y3lsejYwMnRkMmpvZHcwMm02Y2RwIn0.SMI74f_Er2ypi8URBBVdxA',
  embeddableUrl: 'https://embeddable.questatlas.world',
};
